import { useMemo, useState } from 'react';
import { classicScenes } from '@/mocks/home';

const filters = [
  { id: 'all', label: '全部片段' },
  { id: '原版 1993', label: '原版 1993' },
  { id: '3D 版 2011', label: '3D 版 2011' },
];

export default function ClassicScenes() {
  const [filter, setFilter] = useState('all');

  const visible = useMemo(
    () => (filter === 'all' ? classicScenes : classicScenes.filter((s) => s.era === filter)),
    [filter],
  );

  return (
    <section id="scenes" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="reveal flex flex-col md:flex-row md:items-end md:justify-between gap-5">
          <div className="max-w-2xl">
            <span className="text-primary-600 font-label text-sm tracking-wide">经典片段</span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              被影迷反复提起的那些段落
            </h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">
              既有原版里被怀念的经典瞬间，也有 3D 版里最具代表性的拼贴段落。用标签筛一筛，只看你想回顾的部分。
            </p>
          </div>

          <div className="flex flex-wrap gap-2 p-1.5 bg-background-100 rounded-full w-fit">
            {filters.map((item) => (
              <button
                key={item.id}
                type="button"
                onClick={() => setFilter(item.id)}
                aria-pressed={filter === item.id}
                className={`px-4 py-1.5 rounded-full text-xs md:text-sm font-label whitespace-nowrap cursor-pointer transition-colors ${
                  filter === item.id
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-600 hover:text-primary-600'
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {visible.map((scene, index) => (
            <article
              key={scene.title}
              className="reveal bg-background-100/70 border border-background-200/80 rounded-lg p-5 md:p-6 flex flex-col hover:border-primary-300 transition-colors"
              style={{ animationDelay: `${index * 50}ms` }}
            >
              <div className="flex items-center justify-between">
                <span
                  className={`px-2.5 py-0.5 rounded-full text-[11px] font-label whitespace-nowrap ${
                    scene.era.includes('原版')
                      ? 'bg-secondary-100 text-secondary-700'
                      : 'bg-primary-100 text-primary-700'
                  }`}
                >
                  {scene.era}
                </span>
                <span className="text-foreground-400 text-[11px] font-label">#{scene.tag}</span>
              </div>
              <h3 className="mt-4 font-heading text-base md:text-lg font-bold text-foreground-950">
                {scene.title}
              </h3>
              <p className="mt-2 text-foreground-600 text-xs md:text-sm leading-relaxed">{scene.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}